import {
    ToolbarGroup,
    ToolbarButton,
    Modal,
} from '@wordpress/components';

import {
    BlockControls,
} from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";

// Dynamically import all images from the widgets folder
const importAll = (requireContext) => {
    return requireContext.keys().map((key) => {
        // Extract the file name without extension
        const fileName = key.replace('./', '').replace(/\.[^/.]+$/, '');
        // Create a label by replacing hyphens/special characters with spaces and capitalizing words
        const label = fileName
            .replace(/[-_]+/g, ' ') // Replace hyphens or underscores with spaces
            .replace(/[^\w\s]/g, '') // Remove special characters
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize words
        return {
            id: fileName, // Use the original file name as the ID
            img: requireContext(key), // Image path
            label, // Use the formatted label
        };
    });
};

// Presets to be dynamically loaded
const widgetPresets = importAll(require.context("../assets/images/widgets", false, /\.(png|jpg|jpeg|gif|svg)$/));

// Presets specific to "single-doc"
const singleDocPresets = ['light', 'creative', 'box', 'docbox', 'topicsbox'];

// Mapping multi-doc presets to single-doc presets
const styleMapping = {
    light: 'light',
    creative: 'creative',
    box: 'box',
    docbox: 'docbox' // Example: Map topic-box-docs to light
};

export default function PreviewChoose({ attributes, setAttributes }) {

    const { docPreset, docSinglePreset, isPreviewOpen, docTypes } = attributes;

    const closeModal = () => setAttributes({ isPreviewOpen: false });

    function handlePresetPreview(type, value) {
        if (type === 'multi-doc') {
            setAttributes({ docPreset: value });

            // Select corresponding single-doc style
            const mappedSingleDoc = styleMapping[value];
            if (mappedSingleDoc && singleDocPresets.includes(mappedSingleDoc)) {
                setAttributes({ docSinglePreset: mappedSingleDoc });
            }
        } else if (type === 'single-doc') {
            setAttributes({ docSinglePreset: value });

            // Select corresponding multi-doc style
            const mappedMultiDoc = Object.keys(styleMapping).find(
                key => styleMapping[key] === value
            );
            if (mappedMultiDoc) {
                setAttributes({ docPreset: mappedMultiDoc });
            }
        }
        setAttributes({ isPreviewOpen: false });
    }

    function handleChooseStyle() {
        setAttributes({ isPreviewOpen: true });
    }

    // Filter presets based on docTypes
    const filteredPresets = docTypes === 'single-doc'
    ? widgetPresets.filter(preset => singleDocPresets.includes(preset.id))
    : widgetPresets.filter(preset => preset.id !== 'topicsbox'); // Exclude 'topicsbox' for multi-doc
    
    return (
        <>
            <BlockControls group="other">
                <ToolbarGroup>
                    <ToolbarButton
                        icon="welcome-widgets-menus"
                        label={__('Choose Style', 'eazydocs-pro')}
                        onClick={handleChooseStyle}
                    />
                </ToolbarGroup>
            </BlockControls>

            {isPreviewOpen && (
                <Modal title={__('Choose a Style', 'eazydocs-pro')} onRequestClose={closeModal}>
                    <div className='preset-preview'>
                        {filteredPresets.map(preset => (
                            <div
                                key={preset.id}
                                className={`preset ${ docTypes == 'multi-doc' && docPreset === preset.id || docTypes == 'single-doc' && docSinglePreset === preset.id ? 'preset-border' : ''}`}
                                onClick={() => handlePresetPreview(docTypes, preset.id)}
                            >
                                <p><strong>{preset.label}</strong></p>
                                <img src={preset.img} alt={`${preset.label} preview`} />
                            </div>
                        ))}
                    </div>
                </Modal>
            )}
        </>
    );
}